module.exports = __webpack_public_path__ + "static/media/zm.210819bf.svg";